import * as _ from 'lodash';
import { evolve } from '../../utility/evolve'

const accumNodeWithoutEmpty = _.flow(
  accumNode => _.assign(
    _.omitBy(accumNode, _.isEmpty),
    {
      eb_fields: _.omitBy(accumNode.eb_fields, _.isEmpty),
      messages: _.omitBy(accumNode.messages, _.isEmpty),
      custom_filters: _.reject(accumNode.custom_filters || [], _.isEmpty)
    }
  ),
  accumNode => _.omitBy(accumNode, _.isEmpty)
);

const accumRulesWithoutEmpty = _.flow(
  rules => _.map(rules, accumNodeWithoutEmpty),
  rules => _.reject(rules, _.isEmpty)
);

const specialtyWithoutEmpty = _.flow(
  specialty => _.mapValues(specialty, accumRulesWithoutEmpty),
  specialty => _.omitBy(specialty, _.isEmpty)
);

const paymentMethodsWithoutEmpty = _.flow(
  methods => _.mapValues(methods, v => _.reject(v, _.isEmpty)),
  methods => _.omitBy(methods, _.isEmpty)
);

const valueEmpty = v => _.isNull(v)
  || _.isUndefined(v)
  || v === ''
  || (_.isObjectLike(v) && _.isEmpty(v));

const costRulesWithoutEmpty = _.flow(
  evolve({
    payment_methods: _.flow(
      pm => _.mapValues(pm, v => _.reject(v, valueEmpty)),
      pm => _.omitBy(pm, valueEmpty)
    )
  }),
  costRules => _.omitBy(costRules, valueEmpty)
);

const groupWithoutEmpty = group => _.omitBy(group, valueEmpty);

const twoSeventyWithoutEmpty = _.flow(
  twoSeventy => (
    _.mapValues(twoSeventy, value => {
      if (_.isObject(value)) {
        if (!_.some(_.values(value), _.isObject)) {
          return _.omitBy(value, valueEmpty);
        }
        return twoSeventyWithoutEmpty(value);
      }
      return value;
    })
  ),
  twoSeventy => _.omitBy(twoSeventy, valueEmpty)
);

const removeEmpty = evolve({
  two_seventy_one: _.flow(
    twoSeventyOne => _.mapValues(twoSeventyOne, specialtyWithoutEmpty),
    twoSeventyOne => _.omitBy(twoSeventyOne, _.isEmpty)
  ),
  cost_rules: costRulesWithoutEmpty,
  group: groupWithoutEmpty,
  two_seventy: twoSeventyWithoutEmpty
});

const convertCsvStr = _.flow(
  v => v.toString(),
  v => v.split(','),
  v => _.reject(v, _.isEmpty),
  values => values.map(_.flow(
    // special value ""  as input means empty string
    v => v === '""' ? '' : v,
    _.trim
  ))
);
const convertToBool = v => v.toLowerCase() === 'true';

const accumNodeWithCsvConverted = evolve({
  eb_fields: fields => _.mapValues(fields, convertCsvStr),
  messages: msgs => _.mapValues(msgs, convertCsvStr),
  custom_filters: convertCsvStr
});
const accumRulesWithCsvConverted = v => _.map(v, accumNodeWithCsvConverted);
const specialtyWithCsvConverted = sp => _.mapValues(sp, accumNodes => accumRulesWithCsvConverted(accumNodes));

const convertCostRules = _.flow(
  v => _.omitBy(v, valueEmpty),
  evolve({
    deductible_waived: convertCsvStr,
    copay_only_fee_for_service: convertToBool,
    charge_full_when_missing_ebs: convertToBool,
    copay_counts_towards_oop: convertToBool,
    payment_methods: methods => _.mapValues(methods, convertCsvStr)
  }),
);

const twoSeventyWithCsvConverted = twoSeventy => (
  _.mapValues(twoSeventy, value => {
    if (_.isObject(value)) {
      return twoSeventyWithCsvConverted(value);
    }
    return convertCsvStr(value);
  })
);

const convert = evolve({
  two_seventy_one: twoSeventyOne => _.mapValues(twoSeventyOne, specialtyWithCsvConverted),
  cost_rules: convertCostRules
});

const toDbFormat = _.flow(
  convert,
  removeEmpty
);

export {
  toDbFormat,
  accumNodeWithoutEmpty,
  accumRulesWithoutEmpty,
  specialtyWithoutEmpty,
  convertCsvStr,
  convertCostRules,
  paymentMethodsWithoutEmpty,
  costRulesWithoutEmpty,
  groupWithoutEmpty,
  twoSeventyWithoutEmpty,
  valueEmpty
};
